import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styled from 'styled-components'
import Card from '../components/Card'
import Paragraph from '../components/Paragraph'

const ImageWrap = styled.div`
  position: relative;
  cursor: pointer;
`

const Image = styled.img`
  width: 100%;
  position: ${props => props.zIndex === '0' ? 'relative' : 'absolute'};
  z-index: ${props => props.zIndex};
  top: 0;
  left: 0;
  opacity: ${props => props.shown ? '1' : '0'};
  transition: all 1s linear;
`

const Icon = styled.i`
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  color: #fff;
  font-size: 2rem;
  z-index: 10;
`

@observer
export default class OpticNerveProgression extends Component {
  @observable step = 0
  @observable playing = false

  @action
  increment = () => {
    if (this.step === 4) {
      this.playing = false
    } else {
      this.step = this.step + 1
      setTimeout(this.increment, 1000)
    }
  }

  @action
  play = () => {
    this.step = 0
    this.playing = true
    setTimeout(this.increment, 1000)
  }

  render() {
    return (
      <Card>
        <Card.Pad>
          <Paragraph str="prose.opticNerveVideo" />
          <ImageWrap onClick={this.playing ? null : this.play}>
            <Image alt="" src="/images/optic-nerve-progression/1.png" zIndex="0" shown={true} />
            <Image alt="" src="/images/optic-nerve-progression/2.png" zIndex="1" shown={this.step >= 1} />
            <Image alt="" src="/images/optic-nerve-progression/3.png" zIndex="2" shown={this.step >= 2} />
            <Image alt="" src="/images/optic-nerve-progression/4.png" zIndex="3" shown={this.step >= 3} />
            <Image alt="" src="/images/optic-nerve-progression/5.png" zIndex="4" shown={this.step >= 4} />
            <Icon className={this.playing ? "fas fa-sync fa-spin" : "fas fa-play"} />
          </ImageWrap>
        </Card.Pad>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/OpticNerveProgression.js